module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6A0DY"))).then(() => parcelRequire('hEqeo'));